export { default as Input } from './components/input';
export { default as InputNumber } from './components/inputnumber';
export { default as Select } from './components/select';
export { default as DatePicker } from './components/datepicker';
export { default as Form } from './components/form';
export { default as Table } from './components/table';
export { default as ProTable } from './components/protable';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
